import React, { useEffect, useState } from 'react';

// Redux
import { useDispatch } from 'react-redux';

// Utils
import clsx from 'clsx';

// Material UI
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';

// Material Icons
import PostAddIcon from '@material-ui/icons/PostAdd';

// Dropzone
import Dropzone from 'react-dropzone';

// Components
import { ModalTemplate } from 'components/ModalTemplate';
import CloseIcon from 'components/Icons/Close';

// Actions
import { setClose } from 'store/ducks/dialogs/actions';

// Components
import { Processing } from './components/Processing';

// Styles
import useStyles from './styles';

interface UploadVANInterface {
  title: string;
  subtitle: string;
  handleClick: (args: File[]) => void;
}

type Props = UploadVANInterface;

const UploadVAN: React.FC<Props> = ({ title, subtitle, handleClick }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let dropzoneRef: any;

  const [haveFile, setHaveFile] = useState<boolean>(false);

  const onDropAccepted = async (files: File[]) => {
    setHaveFile(true);
    handleClick(files);
  };

  useEffect(() => {
    // Unmount
    return () => {
      setHaveFile(false);
    };
  }, []);

  return (
    <ModalTemplate
      hideCloseIcon
      header={
        <Grid container className={classes.header}>
          <Typography className={classes.title}>
            {haveFile ? 'Verificando dados' : title}
          </Typography>

          <Grid item className={classes.closeIconContainer}>
            <IconButton
              onClick={() => {
                setHaveFile(false);
                dispatch(setClose());
              }}>
              <CloseIcon size='small' />
            </IconButton>
          </Grid>
        </Grid>
      }
      classes={{
        root: classes.resetPtop,
      }}>
      <Grid className={classes.gridContainer} container spacing={0}>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xl={12}
          xs={12}
          className={classes.textContainer}>
          <Grid container justifyContent='center'>
            <Grid item>
              <p className={classes.helpText}>{subtitle}</p>
            </Grid>
          </Grid>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
          <Dropzone
            ref={(node) => {
              dropzoneRef = node;
            }}
            disabled={haveFile}
            accept='.txt'
            onDropAccepted={onDropAccepted}>
            {({
              getRootProps,
              getInputProps,
              isDragActive,
            }: {
              getRootProps: any;
              getInputProps: any;
              isDragActive: boolean;
            }) => (
              <Grid
                alignContent='center'
                container
                justifyContent='center'
                spacing={0}
                {...getRootProps()}
                className={clsx({
                  [classes.dropzone]: !haveFile,
                  [classes.dropzoneCursor]: !haveFile,
                  [classes.dragActive]: isDragActive,
                })}>
                <input {...getInputProps()} />
                {haveFile && (
                  <Grid item>
                    <Processing />
                  </Grid>
                )}
                {!haveFile && (
                  <Grid container justifyContent='center' alignItems='center'>
                    <PostAddIcon color='disabled' style={{ fontSize: 48 }} />
                  </Grid>
                )}
              </Grid>
            )}
          </Dropzone>
        </Grid>
      </Grid>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        marginTop={3}>
        <Box marginRight={2}>
          <Button
            className={clsx(classes.nextButton, classes.maintainButton)}
            onClick={() => {
              setHaveFile(false);
              dispatch(setClose());
            }}>
            cancelar
          </Button>
        </Box>
        <Button
          className={classes.nextButton}
          onClick={(e) => {
            e.preventDefault();

            dropzoneRef.open();
          }}>
          escolher arquivo
        </Button>
      </Box>
    </ModalTemplate>
  );
};

export { UploadVAN };
export default UploadVAN;
